import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";

export const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");
  useEffect(() => {
    const sid = params.get("session_id");
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const r = await axios.get(`${API}/payments/status/${sid}`);
        if (r.data.payment_status === "paid") return setState("paid");
        if (["failed", "expired"].includes(r.data.payment_status)) return setState("failed");
      } catch {}
      if (++tries > 15) return setState("pending");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [params]);

  const text = { checking: "Confirming your payment…", paid: "Payment received — thank you!", failed: "Payment didn't go through.", pending: "Payment is still processing. Check your invoices shortly." };
  return <Result title={text[state]} testId={`payment-${state}`} />;
};

export const PaymentCancel = () => <Result title="Payment cancelled. Your invoice is still open." testId="payment-cancelled" />;

const Result = ({ title, testId }) => (
  <div className="grid min-h-screen place-items-center bg-[#FAF8F5] px-4">
    <div className="max-w-md rounded-2xl border border-[#E6E2DA] bg-white p-10 text-center">
      <p className="eyebrow mb-3">Firm Foundations Construction</p>
      <h1 className="font-display text-2xl font-bold" data-testid={testId}>{title}</h1>
      <Link to="/portal/invoices" className="mt-6 inline-block rounded-full bg-[#F2B91C] px-6 py-3 text-sm font-semibold text-[#0E1F3F]" data-testid="payment-back-btn">Back to invoices</Link>
    </div>
  </div>
);
